import { TrendingUp, Footprints, DoorOpen, Route, Layers, CircleEllipsis } from "lucide-react";
import ServicePageLayout from "@/components/ServicePageLayout";
import usePageMeta from "@/hooks/usePageMeta";
import { useContent } from "@/content/ContentContext";

const APPLICATIONS = [
  {
    icon: TrendingUp,
    title: "Stairs",
    copy: "Steady support going up and down internal and external staircases.",
  },
  {
    icon: Footprints,
    title: "Walkways",
    copy: "Continuous support along walkways and paths around the home.",
  },
  {
    icon: DoorOpen,
    title: "Entrances",
    copy: "A confident handhold right where you come and go every day.",
  },
  {
    icon: Route,
    title: "Paths",
    copy: "Practical rails for garden paths and longer outdoor routes.",
  },
  {
    icon: Layers,
    title: "Steps",
    copy: "Single steps or small flights — made easier and safer to navigate.",
  },
  {
    icon: CircleEllipsis,
    title: "Other Areas",
    copy: "Anywhere around the home where additional support is required.",
  },
];

export default function HandRails() {
  const { get } = useContent();
  usePageMeta(
    get("meta_hand_title", "Hand Rails Perth | Supplied & Installed | Modify"),
    get("meta_hand_desc", "Hand rails supplied and professionally installed across Perth — stairs, steps, entrances and pathways. Secure the whole route. Free quote from Modify.")
  );
  return (
    <ServicePageLayout
      pageTestid="hand-rails-page"
      eyebrow="Hand Rails — Perth, WA"
      title="HAND RAILS FOR SAFER EVERYDAY ACCESS"
      sub="Practical hand rail solutions supplied and professionally installed across Perth."
      heroImg="/images/hand-hero.jpg"
      heroAlt="Stainless steel hand rails installed for a Perth home"
      enquiryTitle="NEED A HAND RAIL INSTALLED?"
      enquiryCopy="Tell us where you need support, send us a photo, and we'll help you find the right solution."
      service="Hand Rails"
      applicationsTitle="Where hand rails can help."
      applications={APPLICATIONS}
      note="Every space is different. Send us a photo of the area and we'll recommend a practical hand rail solution to suit."
      galleryCategory="hand-rails"
      promo={{
        kicker: "Whole-route offer",
        title: "SECURE THE WHOLE ROUTE, NOT JUST THE STEP.",
        body1:
          "A hand rail helps most when the support doesn't stop halfway. The journey from the gate to the front door can involve a path, a step and an entry — a rail at one spot leaves the rest of the route uncovered.",
        body2Strong: "rails for more than one spot",
        body2Rest:
          " Send us a photo of each area — the entry, the steps, the path — and we'll put together a whole-route package quote: one visit, one professional installation, better value. Just mention whole-route package pricing when you enquire.",
        chips: [
          { icon: Footprints, label: "Path + step pairings" },
          { icon: DoorOpen, label: "Front + back entry support" },
          { icon: TrendingUp, label: "Both sides of the stairs" },
        ],
        image: "/images/hand-01.jpg",
        imageAlt: "Modular stainless steel handrail supplied and installed in Perth",
        service: "Hand Rails",
        ctaLabel: "GET A WHOLE-ROUTE QUOTE",
      }}
      ctaTitle="READY FOR SAFER EVERYDAY ACCESS?"
      ctaLabel="GET A QUOTE"
    />
  );
}
